import React from 'react';

const formatCurrency = (value) => `S/ ${(Number(value) || 0).toFixed(2)}`;

const ConfirmationModal = ({
  show,
  onClose,
  confirmationAction,
  formData,
  cancelarForm,
  reprogramarForm,
  convenioForm,
  convenioTotals,
  handleConfirm
}) => {
  if (!show) return null;

  let title = '';
  let message = '';

  switch (confirmationAction) {
    case 'pagar-cuota':
      title = '¿Confirmar pago de cuota?';
      message = `¿Está seguro de registrar el pago de S/ ${parseFloat(formData.monto_pagado).toFixed(2)}` +
        `${formData.fecha_pago ? ` con fecha ${formData.fecha_pago.split('-').reverse().join('/')}` : ''}?`;
      break;
    case 'reducir-mora':
      title = '¿Confirmar reducción de mora?';
      message = `¿Está seguro de aplicar una reducción de ${formData.porcentaje_reduccion}% a la mora?`;
      break;
    case 'cancelar-prestamo':
      title = '¿Confirmar cancelación del préstamo?';
      message = `¿Está seguro de cancelar el préstamo con un pago de S/ ${parseFloat(cancelarForm.monto_pagado).toFixed(2)}` +
        `${cancelarForm.fecha_pago ? ` con fecha ${cancelarForm.fecha_pago.split('-').reverse().join('/')}` : ''}?`;
      break;
    case 'reprogramar-prestamo':
      title = '¿Confirmar reprogramación del préstamo?';
      message = `¿Está seguro de reprogramar el préstamo con una tasa de interés de ${reprogramarForm.tasa_interes}%?`;
      break;
    case 'convenio-prestamo':
      title = '¿Confirmar convenio del préstamo?';
      message = `Se generará un convenio por ${formatCurrency(convenioTotals?.total)} en ${convenioForm.cuotas_convenio} cuota(s)` +
        `${convenioForm.frecuencia ? ` (${convenioForm.frecuencia})` : ''}, iniciando el ${convenioForm.fecha_inicio || 'la fecha indicada'} ` +
        `${convenioForm.excluir_mora ? 'sin mora pendiente' : 'incluyendo la mora vigente'}${convenioForm.solo_capital ? ' y solo sobre el capital pendiente.' : '.'}`;
      break;
    default:
      title = '¿Confirmar acción?';
      message = '¿Está seguro de realizar esta acción?';
  }

  return (
    <div className="modal-overlay" style={{ zIndex: 60 }}>
      <div className="modal-panel modal-panel-sm p-6 text-center">
        <h3 className="modal-title mb-4">{title}</h3>
        <p className="modal-text mb-6">{message}</p>
        <div className="flex justify-center gap-3">
          <button
            onClick={onClose}
            className="btn-modal-neutral"
          >
            No, Cancelar
          </button>
          <button
            onClick={handleConfirm}
            className="btn-modal-danger"
          >
            Sí, Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
